"use strict";

var _defineProperty = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/builds/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInfiniteScroll = exports.defaultFallbackInView = void 0;

var hooks_1 = require("preact/hooks");

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue;

var defaultFallbackInView = function defaultFallbackInView(inView) {
  unsupportedValue = inView;
};

exports.defaultFallbackInView = defaultFallbackInView;

var getRootId = function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}; // options 객체에서 유효한 값을 ID로 변환


var optionsToId = function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return "".concat(key, "_").concat(key === 'root' ? getRootId(options.root || null) : options[key]);
  }).toString();
}; // 옵저버 생성 함수


var createObserver = function createObserver(options) {
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    var elements = new Map();
    var thresholds = Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var extendedEntry = entry;
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        });

        if (options.trackVisibility && typeof extendedEntry.isVisible === 'undefined') {
          extendedEntry.isVisible = inView;
        }

        var callbacks = elements.get(entry.target);

        if (callbacks) {
          callbacks.forEach(function (callback) {
            callback(inView, extendedEntry);
          });
        }
      });
    }, options);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}; // 옵저버에 대상 요소를 등록하고 관찰


var observe = function observe(element, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fallbackInView = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : unsupportedValue;

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {};
  }

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function () {
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}; // useInfiniteScroll 훅 정의 (ResizeObserver 포함)


var useInfiniteScroll = function useInfiniteScroll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView,
      onChange = _ref.onChange,
      onClick = _ref.onClick;

  var _ref2 = (0, hooks_1.useState)(null),
      _ref3 = _slicedToArray(_ref2, 2),
      ref = _ref3[0],
      setRef = _ref3[1];

  var callback = (0, hooks_1.useRef)();

  var _ref4 = (0, hooks_1.useState)({
    inView: !!initialInView,
    entry: undefined
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      state = _ref5[0],
      setState = _ref5[1];

  callback.current = onChange;
  (0, hooks_1.useEffect)(function () {
    if (skip || !ref) return;
    var unobserve; // IntersectionObserver 설정 함수

    var setupObserver = function setupObserver() {
      unobserve = observe(ref, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });
        if (callback.current) callback.current(inView, entry);

        if (entry.isIntersecting && triggerOnce && unobserve) {
          unobserve();
          unobserve = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        trackVisibility: trackVisibility,
        delay: delay
      }, fallbackInView);
    };

    setupObserver(); // 창 크기 변경 시 스크롤 위치 유지

    var handleResize = function handleResize() {
      var scrollPosition = window.scrollY; // 창 크기 변경 시 스크롤이 상단으로 가지 않도록 처리

      setTimeout(function () {
        window.scrollTo(0, scrollPosition);
      }, 0);
    };

    window.addEventListener('resize', handleResize);
    return function () {
      if (unobserve) {
        unobserve();
      }

      window.removeEventListener('resize', handleResize); // 이벤트 해제
    };
  }, [Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  var entryTarget = state && state.entry && state.entry.target;
  var previousEntryTarget = (0, hooks_1.useRef)(null);

  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: undefined
    });
  }

  var handleClick = function handleClick() {
    setState(function (prevState) {
      return _objectSpread({}, prevState, {
        inView: !prevState.inView
      });
    });

    if (onClick) {
      onClick(!state.inView);
    }
  };

  return {
    ref: setRef,
    inView: state.inView,
    entry: state.entry,
    handleClick: handleClick
  };
};

exports.useInfiniteScroll = useInfiniteScroll;